<div class="bg-white rounded-lg shadow-sm p-6">
  <h2 class="text-xl font-bold mb-4">Método de pago</h2>

  <!-- Visa (seleccionado) -->

  <!-- <mercado-pago-list-cards-user></mercado-pago-list-cards-user> -->

  <!-- PayPal -->
  <!-- <div class="border border-gray-200 rounded-lg p-4 mb-3 flex items-center justify-between">
    <div class="flex items-center">
      <div class="text-blue-500 mr-3">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2z" />
        </svg>
      </div>
      <div class="font-medium">PayPal</div>
    </div>
    <div class="h-5 w-5 rounded-full border border-gray-300 flex items-center justify-center"></div>
  </div> -->

  <!-- Efectivo -->


 
  <!-- Botón de confirmar pedido -->
  <shared-mercado-pago #tarjetas></shared-mercado-pago>

  <!-- Mensaje informativo -->
  <div
    class="text-center text-gray-500 text-sm mt-4 flex items-center justify-center"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-4 w-4 mr-1"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
    Tu pedido será preparado una vez confirmado el pago
  </div>
</div>
